import { render, staticRenderFns } from "./PostViewDetail.vue?vue&type=template&id=147db434&scoped=true&"
import script from "./PostViewDetail.vue?vue&type=script&lang=js&"
export * from "./PostViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./PostViewDetail.vue?vue&type=style&index=0&id=147db434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147db434",
  null
  
)

export default component.exports